export default __webpack_public_path__ + "static/media/6.cf2ddfa8.jpg";